const OdometerAnimation = {
    init: function () {
        const resultsElement = document.querySelector('.results__grid');
        const resultNumbers = [...document.querySelectorAll('.results__grid__card__number__data')];

        window.odometerOptions = {
            auto: false,
            format: 'd',
            theme: 'minimal',
            duration: 500,
            animationDirection: 'up'
        }

        const observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                [...odometer].forEach((el, index) => {
                    const resultNumber = parseInt(resultNumbers[index].innerText.replace(/\./g, ''));
                    const meter = new Odometer({
                        el: el,
                    });
                    meter.update(resultNumber);
                });
            }
        }, {
            threshold: 1
        });
        
        if(resultsElement) {
            observer.observe(resultsElement);
        }
    }
};

export default OdometerAnimation;
